import React from 'react'
import { Link } from 'react-router-dom'

export default function GamePromotion({
                                          title = 'Alice in Dreamland',
                                          slug = 'alice',
                                          showMeet = true,
                                          altText
                                      }) {
    const imageUrl = `/images/game-logos/${slug}.png`
    const alt = altText || `${title} game promo`

    return (
        <Link to={`/blog#${slug}`} className='game-promotion-link'>
            <section className='game-promotion-section'>
                <div className='game-promotion-heading'>
                    {showMeet && (
                        <div className='game-promotion-meet'>Meet:</div>
                    )}
                    <div className='game-promotion-title'>
                        <h2>{title}</h2>
                    </div>
                </div>
                <img
                    src={imageUrl}
                    alt={alt}
                    className='game-promotion-img'
                    loading='lazy'
                />
            </section>
        </Link>
    )
}
